import { ACTIONS } from '_redux/actions';

const initialState = {
  content: {},
  contentLoading: true,
};

export default function page(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.PAGE.FETCH_CONTENT: {
      return {
        ...state,
        contentLoading: true,
      };
    }

    case ACTIONS.PAGE.FETCH_CONTENT_SUCCESS: {
      return {
        ...state,
        content: {
          contentClassName: action.payload.params.contentClassName,
          ...action.payload.data,
        },
        contentLoading: false,
      };
    }

    case ACTIONS.PAGE.PRE_FETCH_CONTENT_SUCCESS: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
}
